<table mat-table [dataSource]="notes" class="mat-elevation-z1 w-100 mh-600">
	<ng-container matColumnDef="sequenceNumber">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'mes.reorder-note-list.headers.sequenceNumber' | translate }}
		</th>
		<td mat-cell *matCellDef="let note">{{ note.sequenceNumber }} {{ getPartInfo(note.itemAlias) }}</td>
	</ng-container>

	<ng-container matColumnDef="createdAt">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'mes.reorder-note-list.headers.created-date' | translate }}
		</th>
		<td mat-cell *matCellDef="let note">
			{{ note.createdAt | date: ('mes.reorder-note-list.date-format' | translate) }}
		</td>
	</ng-container>

	<ng-container matColumnDef="createdBy">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'mes.reorder-note-list.headers.created-by' | translate }}
		</th>
		<td mat-cell *matCellDef="let note">{{ getEmployeeName(note.createdBy) }}</td>
	</ng-container>

	<ng-container matColumnDef="note">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'mes.reorder-note-list.headers.note' | translate }}
		</th>
		<td mat-cell *matCellDef="let note">{{ note.note }}</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns" [ngClass]="{ 'group-separator': isGroupChange(i) }"></tr>
</table>
